import {layoutSelectors} from 'features/layout/redux';
import React from 'react';
import {useSelector} from 'react-redux';

export const useEnsurePartnerFolderId = () => {
   const folders = useSelector(layoutSelectors.getFolders);

   const cb = React.useCallback(
      (folderId, objectType) => {
         const currentParent = folders.find((fs) => fs.id === folderId);

         if (currentParent?.childObjectType === objectType) {
            return folderId;
         } else {
            folders.find((fs) => fs.childObjectType === objectType && fs.level === 2);
         }
      },
      [folders]
   );

   return cb;
};
